import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
} from 'reactstrap';

import Grid from '../../components/cms/grid';

const initCriteria = {
  id: '',
  sortBy: 'id',
  order: 'desc',
};

const Items = ({ t, getColumns, service }) => (
  <div>
    <Row>
      <Col xl={12}>
        <Card>
          <CardHeader>
            <strong><i className="fa fa-play" /> {t('Videos')}</strong>
          </CardHeader>
          <CardBody>
            <Grid
              id="videos"
              service={service}
              columns={getColumns(t)}
              initCriteria={initCriteria}
            />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

Items.propTypes = {
  t: PropTypes.func.isRequired,
  getColumns: PropTypes.func.isRequired,
};

export default Items;



// WEBPACK FOOTER //
// ./src/views/videos/Items.jsx